export default __webpack_public_path__ + "static/media/thumbnail.53db9864.png";